import React, {Fragment} from 'react';
import {priority, themes} from '../../constants';
import Button from '../button/Button';
import Message from '../message/Message';

import styles from './AlertPrompts.pcss';

export interface PromptRenderProps {
    onCancel?: (e: React.SyntheticEvent) => void;
    onClose?: (e: React.SyntheticEvent) => void;
    onConfirm?: (e: React.SyntheticEvent) => void;
    title?: string;
    message?: string;
}

export const DefaultConfirmationAlert = ({title, message, onClose}: PromptRenderProps) => {
    return (
        <Fragment>
            <h3 className={styles.title}>{title}</h3>
            <p className={styles.description}>{message}</p>
            <Button priority={priority.TERTIARY} onClick={onClose}>
                <Message code="diesel.main.prompts.buttons.ok" />
            </Button>
        </Fragment>
    );
};

export const CancelableConfirmationAlert = ({
    title,
    message,
    onClose,
    onConfirm
}: PromptRenderProps) => {
    return (
        <Fragment>
            <h3 className={styles.title}>{title}</h3>
            <p className={styles.description}>{message}</p>
            <Button priority={priority.PRIMARY} onClick={onConfirm}>
                <Message code="diesel.main.prompts.buttons.ok" />
            </Button>
            <Button priority={priority.TERTIARY} onClick={onClose}>
                <Message code="diesel.main.prompts.buttons.cancel" />
            </Button>
        </Fragment>
    );
};

export const ApplyChangesAlert = ({onClose, onConfirm, title, message}: PromptRenderProps) => {
    return (
        <Fragment>
            <h3 className={styles.title}>{title}</h3>
            <p className={styles.description}>{message}</p>
            <Button priority={priority.PRIMARY} onClick={onConfirm}>
                <Message code="diesel.main.prompts.buttons.apply_changes" />
            </Button>
            <Button theme={themes.BLACK} onClick={onClose}>
                <Message code="diesel.main.prompts.buttons.no_thanks" />
            </Button>
        </Fragment>
    );
};
